import { LoyaltySvgIcon, type LoyaltyIconProps } from './LoyaltySvgIcon';

export const JuiceIcon = (props: LoyaltyIconProps): JSX.Element => (
    <LoyaltySvgIcon {...props}>
        <path d="M6.7 8.2h10.6l-1.28 13.1c-.06.6-.56 1.05-1.16 1.05H9.14c-.6 0-1.1-.45-1.16-1.05L6.7 8.2z" />
        <path d="M14.6 8.2l3.1-4.9 1.55.98-2.48 3.92H14.6z" />
    </LoyaltySvgIcon>
);
